var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendedEvse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.755 11.4975L20.255 10.7475C19.9775 10.6125 19.6325 10.7175 19.4975 10.995C19.355 11.28 19.4675 11.6175 19.745 11.7525L20.9375 12.345V15.9375L18.125 15.945V8.25C18.125 6.75 17.12 6 15.875 6H9.875C8.63 6 7.625 6.75 7.625 8.25V20.4375H6.5C6.1925 20.4375 5.9375 20.6925 5.9375 21C5.9375 21.3075 6.1925 21.5625 6.5 21.5625H19.25C19.5575 21.5625 19.8125 21.3075 19.8125 21C19.8125 20.6925 19.5575 20.4375 19.25 20.4375H18.125V17.07L21.5 17.0625C21.815 17.0625 22.0625 16.8075 22.0625 16.5V12C22.0625 11.79 21.9425 11.595 21.755 11.4975ZM9.5 9.6675C9.5 8.625 10.1375 8.25 10.9175 8.25H14.84C15.6125 8.25 16.25 8.625 16.25 9.6675V10.59C16.25 11.625 15.6125 12 14.8325 12H10.9175C10.1375 12 9.5 11.625 9.5 10.5825V9.6675ZM9.875 13.6875H12.125C12.4325 13.6875 12.6875 13.9425 12.6875 14.25C12.6875 14.5575 12.4325 14.8125 12.125 14.8125H9.875C9.5675 14.8125 9.3125 14.5575 9.3125 14.25C9.3125 13.9425 9.5675 13.6875 9.875 13.6875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendedEvse);
export default __webpack_public_path__ + "static/media/suspendedEVSE.088bdc8cab4d1b79fb344ee84dcff357.svg";
export { ForwardRef as ReactComponent };